/**
 * Process 工作流程
 * @type {{}}
 */
import Vue from "vue";
import { Input, Icon, Message,Modal,Button } from "view-design";
Vue.component('Input', Input);
Vue.component('Icon', Icon);
Vue.component('Modal', Modal);
Vue.component('Button', Button);
import { getDeviceClassAllService,
    addDeviceClassService,
    updateDeviceClassService,
    delDeviceClassService } from '@/service/device-class-service'
import { mapMutations, mapState } from "vuex";
import $event, { EVENT_NAME } from "@/utils/event-emitter";
const Process = {
    name:'Process',
    computed: {
        ...mapState({
            selectedMenuId: state => state.system.selectedMenuId, //选中的菜单Id
            menuVisible: state => state.system.menuVisible, //菜单显示状态
        }),
    },
    data() {
        return {
            windowWidth:window.innerWidth, //获取窗口宽度
            deviceModalVisible:false, //设备分类modal弹框可显示
            deviceLoading:false, //设备分类modal弹框 loading
            deviceListArray:[], //设备分类数据
            deviceName:'', //设备名称
            deviceId:'', //设备id
            btnStatus:false, //按钮状态
        }
    },
    created() {
        // if(this.selectedMenuId.length!==0){
        //     this.$router.push('/device/list')
        // }
        // this.onDeviceClassAll().then()
    },
    methods: {
        ...mapMutations('system',['SET_CLASSIFY_MENU_ARRAY','SET_SELECTED_MENU_ID']),

        /**
         * 跳转携带id
         * @param id
         */
        onLinks(deviceId,childrenId,childId){
            this.SET_SELECTED_MENU_ID([-1,childrenId,childId])
            if(this.$route.path!=='/device/list'){
                this.$router.push('/device/list')
            }else{
                $event.$emit(EVENT_NAME.DEVICE_MENU_LIST)
            }
        },
        /**
         * 添加根结点设备
         */
        onAddDevice(){
            this.btnStatus = true
            this.deviceModalVisible = true
            this.deviceName = ''
            this.deviceId = ''
        },
        /**
         * 添加设备分类验证
         */
        onAddDeviceCheck(){
            if(this.deviceName === ''){
                Message.error('请输入设备名称！')
                return;
            }
            this.btnStatus?this.onAddDeviceClass().then():this.onUpdateDeviceClass().then()

        },
        /**
         * 添加二级设备
         * @param id
         */
        onChildAddDevice(id){
            this.btnStatus = true
            this.deviceModalVisible = true
            this.deviceName = ''
            this.deviceId = id
        },
        /**
         * 修改设备分类
         * @param id
         */
        onUpdateDevice(obj){
            console.log(obj)
            this.btnStatus = false
            this.deviceModalVisible = true
            this.deviceName = obj.name
            this.deviceId = obj.value
        },
        /**
         * 删除设备
         * @param id
         */
        onDelDevice(id){
            Modal.confirm({
                title: '提示',
                content: '<p>您确定要删除吗？</p>',
                loading:true,
                onOk: () => {
                    this.onDelDeviceClass(id).then()
                }
            });
        },
        /**
         * 添加设备分类
         * @returns {Promise<void>}
         */
        async onAddDeviceClass(){
            try {
                this.deviceLoading = true
                let params = {
                    parentId:this.deviceId,
                    name:this.deviceName,
                }
                const { code } = await addDeviceClassService(params)
                if(code === 'SUCCESS'){
                    this.deviceName = ''
                    this.deviceId = ''
                    Message.success('添加成功！')
                    this.onDeviceClassAll().then()
                    this.deviceModalVisible = false
                }else if(code === 'EQUIPMENT_CLASSIFICATION_NODE_REPEAT_NAME'){
                    Message.error('请勿重复添加设备名称！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.deviceLoading = false

            }catch (error){
                this.deviceLoading = false
                console.log(error)
            }
        },
        /**
         * 修改设备分类
         * @returns {Promise<void>}
         */
        async onUpdateDeviceClass(){
            try {
                this.deviceLoading = true
                let params = {
                    id:this.deviceId,
                    newName:this.deviceName,
                }
                const { code } = await updateDeviceClassService(params)
                if(code === 'SUCCESS'){
                    this.deviceName = ''
                    this.deviceId = ''
                    Message.success('修改成功！')
                    this.onDeviceClassAll().then()
                    this.deviceModalVisible = false
                }else if(code === 'EQUIPMENT_CLASSIFICATION_NODE_REPEAT_NAME'){
                    Message.error('请勿重复添加设备名称！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.deviceLoading = false

            }catch (error){
                this.deviceLoading = false
                console.log(error)
            }
        },
        /**
         * 删除设备分类
         * @returns {Promise<void>}
         */
        async onDelDeviceClass(id){
            try {
                this.deviceLoading = true
                let params = {
                    id:id,
                }
                const { code } = await delDeviceClassService(params)
                if(code === 'SUCCESS'){
                    Message.success('删除成功！')
                    this.onDeviceClassAll().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.deviceLoading = false
                Modal.remove();
            }catch (error){
                Modal.remove();
                this.deviceLoading = false
                console.log(error)
            }
        },
        /**
         * 获取所有设备分类
         */
        async onDeviceClassAll() {
            try {
                const { code,data } = await getDeviceClassAllService()
                if(code === 'SUCCESS'){
                    for(let i in data){
                        data[i].visible = true
                        data[i].id = -1
                        if(data[i].childNode.length!==0){
                            for(let j in data[i].childNode){
                                data[i].childNode[j].visible = true
                            }
                        }
                    }
                    this.deviceListArray = this.onReplaceAttribute(data)
                    this.SET_CLASSIFY_MENU_ARRAY(this.deviceListArray)
                }else{
                    Message.error('请求异常，请联系管理员！')
                }

            }catch (error){
                console.log(error)
            }
        },
        /**
         * 替换属性名
         * @param data
         */
        onReplaceAttribute(data){
            let item = []
            data.map(list => {
                let newData = {}
                newData.value = list.id;
                newData.label = list.name;
                newData.visible = list.visible;
                newData.children = list.childNode;
                if(list.childNode){
                    newData.children = this.onReplaceAttribute(list.childNode)
                }
                item.push(newData)
            })
            return item
        },
    },
    destroyed () {
    }
}
export default Process
